import { observer } from 'mobx-react';

import Image from 'next/image';
import { useRouter } from 'next/router';

import { makeStyles } from '@bequestinc/wui';
import { Button, Grid, Paper, Typography } from '@mui/material';

const useStyles = makeStyles()(theme => ({
  virtualOfficeBanner: {
    position: 'relative',
    boxShadow: `0px 3px 5px ${theme.palette.grey['300']}`,
    borderRadius: 16,
    padding: 20,
    border: '3px solid transparent',
    backgroundImage: `
      linear-gradient(#ffffff, #ffffff),
      linear-gradient(90deg, #1e88e5, #8bc34a)
    `,
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
  },
  virtualOfficeBannerTitle: {
    color: '#0066A6',
    fontWeight: 500,
    fontSize: '24px',
    paddingTop: '0px',
  },
  virtualOfficeButton: {
    backgroundColor: '#0066A6',
    padding: '10px 20px 10px 20px',
    height: '85%',
  },
  availableNowTag: {
    backgroundColor: '#FFDA83',
    color: 'black',
    height: '80%',
    fontWeight: 'light',
    '&.Mui-disabled': {
      backgroundColor: '#FFDA83',
      color: 'black',
    },
  },
  virtualOfficeSubtitle: {
    fontSize: '15px',
    lineHeight: '18px',
    color: 'black',
  },
}));

const VirtualOfficeBanner = () => {
  const router = useRouter();
  const { classes } = useStyles();

  return (
    <Paper className={classes.virtualOfficeBanner}>
      <Grid container direction="row" justifyContent="center" alignItems="center" spacing={5}>
        <Grid item xs={4}>
          <Image
            src="/images/virtual-office.png"
            alt="Virtual Office"
            width={400}
            height={200}
            quality={60}
            style={{ width: '110%', height: 'auto' }}
          />
        </Grid>
        <Grid container item xs={8} direction="column" spacing={2}>
          <Grid item xs={3}>
            <Button variant="contained" className={classes.availableNowTag} disabled>
              Available Now
            </Button>
          </Grid>
          <Grid item>
            <Typography className={classes.virtualOfficeBannerTitle}>
              Grow Your Client Base Beyond Your Zip Code
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.virtualOfficeSubtitle}>
              With Virtual Office enabled, your profile can become visible to members statewide: not
              just those in your immediate area. Turn it on to start connecting with more clients
              today.
            </Typography>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              className={classes.virtualOfficeButton}
              onClick={() => router.push('/firm-info?offices=true')}
            >
              ENABLE VIRTUAL OFFICE
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default observer(VirtualOfficeBanner);
